(function() {
	'use strict';

	angular
		.module('assetCommon')
		.factory('layoutUtility', layoutUtility);

	function layoutUtility() {
		function isSmallScreen() {
			return window.innerWidth < 1024;
		}

		return {
			isSmallScreen: isSmallScreen
		};
	}
})();